<div class="navigation-item-container" (click)="itemClicked()" data-bs-dismiss="offcanvas">
    <div class="image-container d-flex align-items-center justify-content-center">
        <div class="image-content d-flex flex-column align-items-center justify-content-center">
            <img *ngIf="item?.imageUrl" [alt]="item?.title" [src]="item?.imageUrl">
        </div>
    </div>
    <div class="header-title">
        {{item?.title}}
    </div>
</div>